<template>
  <div class="component form-input input-item" v-bind:class="[{ error }, type, icon]">
    <span class="icon" v-if="icon" v-bind:class="icon"></span>
    <div class="input">
      <input ref="formInputInput" :type="type" :id="elementId" :placeholder="label" v-if="type!='textarea' && type!='select' && type!='radio' && type!='stripe-field'" :autocomplete="autocomplete" :readonly="readonly" :required="required" v-model="modelValue" v-on:focus="focus" @blur="blur">
      <input ref="formInputInputRadio" type="radio" :id="elementId" :placeholder="label" v-if="type==='radio'" :value="radioValue" v-model="modelValue">
      <textarea ref="formInputTextarea" :id="elementId" :placeholder="label" v-if="type=='textarea'" :autocomplete="autocomplete" :readonly="readonly" :required="required" v-model="modelValue" v-on:focus="focus"></textarea>
      <select ref="formInputSelect" :id="elementId" v-if="type=='select'" :autocomplete="autocomplete" v-model="modelValue" v-on:focus="focus">
        <option v-for="(option, index) in selectOptions" :key="index" :value="option.value" :disabled="option.disabled">{{ option.label }}</option>
      </select>
      <label :class="type==='stripe-field' ? 'stripe-label' : ''" :for="elementId">{{ label }}</label>

      <div v-if="type==='stripe-field'" class="stripe">
        <div :id="elementId" class="stripe-element"></div>
      </div>

      <div class="info" v-if="info">{{ info }}</div>
      <div class="description" v-if="description">{{ description }}</div>
      <div class="error-message">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },

  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      required: true
    },
    id: String,
    value: [String, Number, Date, Boolean],
    radioValue: String,
    autocomplete: String,
    readonly: Boolean,
    required: Boolean,
    error: String,
    description: String,
    info: String,
    icon: String,
    options: [String, Array]
  },

  data() {
    return {
      val: this.value ? this.value : undefined,
      isFocus: false
    }
  },

  beforeUpdate(){
    this.formatValue();
  },

  mounted(){
    this.formatValue();
    //this.setSelection();
  },

  watch: {
    value(newVal){
      this.val = newVal;
    },
    // This is code for preselecting dropdowns with the first available option
    // options(newOptions){
    //   this.setSelection();
    // }
  },

  computed: {
    elementId() {
      return this.id !== undefined ? this.id : 'form-input-' + Math.random().toString(16).slice(2)+(new Date()).getTime()+Math.random().toString(16).slice(2);
    },

    selectOptions() {
      let options = [];
      if (this.options === 'ccMonths') {
        options = this.createOptions(['01','02','03', '04', '05', '06', '07', '08', '09', '10', '11', '12']);
      } else if (this.options === 'ccYears') {
        let y = new Date().getFullYear();
        for (let i = y; i <= y+10; i++) {
          options.push({
            label: i,
            value: i
          });
        }
      } else {
        options = this.createOptions(this.options);
      }

      return options;
    },

    modelValue: {
      get() {
        return this.val;
        // return this.type === 'select' && !this.value && this.selectOptions.length > 0 ? this.selectOptions[0].value : this.value;
      },
      set(val) {
        if (this.type.toLowerCase() === 'checkbox' && this.$refs.formInputInput) {
          this.val = this.$refs.formInputInput.checked;
        } else {
          this.val = val;
        }
        this.$emit('input', this.val);
      }
    }
  },

  /************* 
   * Removing these callbacks to ensureSelectedValue due to timing issues and the ensureSelectedValue method
   * overwriting expected values.
   * Make sure a value is set /outside/ of this component. Don't try to do it from within here. 
   *
   */
  // created() {
  //   this.ensureSelectedValue();
  // },

  // watch: {
  //   options() {
  //     this.ensureSelectedValue();
  //   }
  // },

  methods: {
    focus() {
      this.isFocus = true;
      this.$emit('focus');
    },

    setSelection(){
      // Don't preselect on the p2p page
      if(this.$route.name === "p2p"){
        return;
      }
      if(this.type === "select" && this.selectOptions.length && (!this.modelValue || !this.selectOptions.some((option) => option.value === this.modelValue))){
        for (let option of this.selectOptions){
          if (!option.disabled && option.value){
            this.modelValue = option.value;
            return;
          }
        }
      }
    },

    blur() {
      this.isFocus = false;
      this.formatValue();
      this.$emit('blur');
    },

    // probably should use this on any lifecycle events (created, watch, etc). See comment above. 
    ensureSelectedValue() {
      if (this.type === 'select' && this.options && this.options.length && !this.selectOptions.filter(item => item.value === this.modelValue).length) {
        // Timing issue on create. Need to defer this set to the next render clock tick.
        setTimeout(() => {
          this.modelValue = this.selectOptions[0].value;
        }, 0);
      }
    },

    createOptions(arr) {
      let options = [];
      if (arr && arr.length > 0) {
        options = arr;

        if (typeof(options[0]) !== 'object') {
          options = options.map(item => ({ label: item, value: item }));
        }
      }
      return options;
    },
    
    formatValue(){
      if(this.$parent.$el.className === 'view giftcert' && this.type === 'number' && !this.isFocus){
        this.val = Number.parseFloat(this.val).toFixed(2);
      } else {
        this.val = this.val;
      }
    }
  }
};
</script>

<style lang="scss">
.component.form-input {
  display: flex;
  margin-bottom: 20px;

  .icon {
    color: $colorDarkGray;
    font-size: 20px;
    line-height: 50px !important;
    width: 25px;
    min-width: 25px;
    margin-right: 15px;
    text-align: center;
    @include breakpoint(medium) {
      color: $colorGray;
      position: absolute;
      line-height: 45px !important;
      z-index: 1;
      margin-left: 10px;
      font-size: 18px;
    }

    &.guest {
      @include font-awesome($fa-var-user, light);
    }
  }

  .input {
    position: relative;
    width: 100%;

    input:not([type='checkbox']), textarea {
      width: 100%;
      @include breakpoint(medium) {
        &:not(textarea){
          padding-left: 40px;
        }
      }

      & + label {
        @include font-input;
        position: absolute;
        line-height: 50px;
        top: 0;
        left: 15px;
        color: $colorGray;
        white-space: nowrap;
        transition: all .2s;
        z-index: 1;
        @include breakpoint(medium) {
          line-height: 45px;
          transition: all .1s;
        }

        &::before {
          content: "";
          background-color: #fff;
          width: calc(100% + 10px);
          height: 3px;
          display: inline-block;
          position: absolute;
          top: 6px;
          left: -5px;
          z-index: -1;
        }
      }

      &::placeholder {
        font-size: 0;
      }

      &:not(:focus) + label {
        @include breakpoint(medium){
          padding-left: 25px;
        }
      }

      &:not(:placeholder-shown) + label {
        padding-left: 0;
        @include font-smaller;
        color: $colorDarkGray;
        top: -6px;
        @include breakpoint(medium) {
          left: 15px;
        }
      }

      &:focus + label {
        @include font-smaller;
        color: $colorBlue;
        top: -6px;
        @include breakpoint(medium) {
          left: 15px;
        }
      }

      /* Edge - placehoder-shown doesn't work, so stick the label top left */
      @supports (-ms-ime-align:auto) {
        &::-webkit-input-placeholder {
          opacity: 0;
        }

        & + label {
          @include font-smaller;
          color: $colorDarkGray;
          top: -6px;
          @include breakpoint(medium) {
            left: 15px;
          }
        }
      }

      /*  IE */
      @media all and (-ms-high-contrast:none) {
        &::-webkit-input-placeholder {
          opacity: 0;
        }

        & + label {
          @include font-smaller;
          color: $colorDarkGray;
          top: -6px;
          left: 15px;
        }
      }
    }

    select {
      width: 100%;
      @include breakpoint(medium) {
        padding-left: 40px;
      }

      & + label {
        @include font-smaller;
        white-space: nowrap;
        color: $colorDarkGray;
        position: absolute;
        left: 15px;
        top: -6px;
        z-index: 1;

        &::before {
          content: "";
          background-color: #fff;
          width: calc(100% + 10px);
          height: 3px;
          display: inline-block;
          position: absolute;
          top: 5px;
          left: -5px;
          z-index: -1;
        }
      }

      &:focus + label {
        color: $colorBlue;
      }
    }

    .error-message {
      display: none;
    }

    .info, .description {
      font-size: 13px;
      line-height: 21px;
      color: $colorGray;
    }
  }

  &.error {
    .error-message {
      display: block;
      @include font-small;
      color: $colorRed;
    }

    .icon {
      color: $colorRed;
    }

    input, select {
      border-color: $colorRed;

      &:focus {
        box-shadow: inset 0 0 0 1px $colorRed;

        & + label {
          color: $colorRed !important;
        }
      }
    }
    input[type="checkbox"] {
      &+label::before {
        color: $colorRed;
      }
    }
  }

  &.highlighted-info .info {
    color: $colorGreen;
  }

  .stripe {
    -webkit-writing-mode: horizontal-tb !important;
    text-rendering: auto;
    color: -internal-light-dark-color(black, white);
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    background-color: -internal-light-dark-color(white, black);
    -webkit-rtl-ordering: logical;
    cursor: text;
    font: 400 13.3333px Arial;

    box-sizing: inherit;
    margin: 0;
    overflow: visible;
    font-family: inherit;

    padding: 0 15px;
    border: 1px solid $colorPaleGray;
    border-radius: 4px;
    -webkit-appearance: none;
    outline: none;

    height: 45px;
    width: 100%;
    padding-left: 15px;
    position: relative;

    .stripe-element {
      width: 100%;
      padding: 15px 0px;
      margin: 0;
      position: absolute;
      top: 50%;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }

  .stripe-label {
    @include font-input;
    position: absolute;
    line-height: 50px;
    top: 0;
    left: 15px;
    color: $colorGray;
    white-space: nowrap;
    transition: all .2s;
    z-index: 1;
    @include breakpoint(medium) {
      /*line-height: 45px;*/
      transition: all .1s;
    }

    &::before {
      content: "";
      background-color: #fff;
      width: calc(100% + 10px);
      height: 3px;
      display: inline-block;
      position: absolute;
      top: 6px;
      left: -5px;
      z-index: -1;
    }

    @include font-smaller;
    color: $colorDarkGray;
    top: -6px;
    @include breakpoint(medium) {
      left: 15px;
    }
  }
}
</style>